export default __webpack_public_path__ + "static/media/home-about-us.1f1cd1d4.webm";